<template>
  <div class="ActivationCode">
    <div class="yui_page-main">


      <div style=" padding: 5vw;">
        <div class="exchange_coupon">
          <div class="yui_icon">

            <img :src="onCodeCateory.icon" alt="">
          </div>
          <div class="coupon-info">
            <h5>{{ onCodeCateory.productName }}</h5>


          </div>

          <div class="yui_ft">
            <p>
              {{ onCodeCateory.coinNum }}个能量
            </p>
          </div>
        </div>

        <div class="exchange-history" v-show="logList&&logList.length>0">
          <div style="padding: 3vw 3vw;text-align:center;">
            兑换记录
          </div>
          <div>
            <van-cell-group :border="false">
              <cell-activition-code v-for="(item,index) in logList"
                                    :logInfo="item"
                                    v-on:prepaidRefill="prepaidRefill"
                                    :cell-type="onCodeCateory.type"
                                    :key="'l_'+index"
                                    :create-time="item.createTime"
                                    :product-id="item.productId"
                                    :mobile-no="item.mobileNo"
                                    :status="item.status"
                                    :order-no="item.orderNo"
                                    :c-d-key="item.CDKey"/>
              <!--            <van-cell center

                                    class="y_cell-activity-code"
                                    :label="item.createTime" >
                            <template #title>
                              <span class="custom-title">兑换码</span> <br>
                              <span>{{item.CDKey}}</span>

                            </template>

                              <van-button plain
                                          hairline
                                          size="mini"
                                          round
                                          color="#595959"
                                          style="padding-left: 1.5vw;padding-right: 1.5vw;"
                                          type="info">复制兑换码</van-button>


                          </van-cell>-->

              <!--      <van-cell title="单元格" value="内容" label="描述信息" />-->
            </van-cell-group>
          </div>

        </div>

      </div>


      <div class="use-rule">
        使用规则
        <pre>{{ onCodeCateory.rule }}</pre>
      </div>
    </div>
    <div class="yui_footer">
      <van-button round
                  hairline
                  plain
                  block
                  @click="toExchange"
                  type="warning"
                  color="#2FBD4B">立即兑换
      </van-button>
    </div>


    <van-dialog v-model="dialogPrepaidRefillShow"
                title="再次充值"
                confirm-button-text="确认兑换"
                confirm-button-color="#2FBD4B"
                @confirm="toRecharge"
                :before-close="dialogExchangePhoneBillBeforeClose"
                show-cancel-button>
      <br>
      <label class="yui-input-box">
        <input class="yui-input"
               type="tel"
               name="phone"
               id="phoneTel"
               v-model="dialogPhone"
               v-number-only
               maxlength="11"
               placeholder="请输入充值手机号">
      </label>
    </van-dialog>
    <van-dialog v-model="dialogExchangePhoneBillShow"
                :title="onCodeCateory.productName"
                confirm-button-text="确认兑换"
                confirm-button-color="#2FBD4B"
                @confirm="toExchangePhoneBill(onCodeCateory.productId)"
                :before-close="dialogExchangePhoneBillBeforeClose"
                show-cancel-button>
      <p style="font-size: 3vw;color: #999999;text-align:center;">
        将消耗{{ onCodeCateory.coinNum }}能量
      </p>
      <label class="yui-input-box">
        <input class="yui-input"
               type="tel"
               name="phone"
               id="phoneTel2"
               v-model="dialogPhone"
               v-number-only
               maxlength="11"
               placeholder="请输入充值手机号">
      </label>
    </van-dialog>

    <van-dialog v-model="dialogExchangeCodeShow"
                title="兑换成功"

                confirm-button-color="#2FBD4B"
                @confirm="getPageInfo">
      <p style="text-align:center;">
        权益兑换码为： <br>
        {{ onExchangeCodeObj.param }}
      </p>
      <van-button round

                  data-clipboard-action="copy"
                  :data-clipboard-text="onExchangeCodeObj.param"
                  @click="copyExchangeCode"
                  class="y_btn cobyOrderSn"
                  plain hairline
                  type="warning"
                  size="mini"
                  color="#f56134">
        复制兑换码
      </van-button>
    </van-dialog>

  </div>
</template>

<script>
import {
  costCoin,
  findCostLogList,
  recharge
} from "@/services/api";
import cellActivitionCode from "@/views/exchange/components/cell-activition-code";
import exchangeList from "@/views/exchange/exchangeList";
import {
  phoneFilter2
} from "@/libs/tools";
import {ActivityStartTime} from "@/config";

export default {
  name: "activationCode",
  components: {
    cellActivitionCode
  },

  data() {
    return {
      logList: [],
      onExchangePhoneBillObj: {},
      dialogPrepaidRefillShow: false,
      dialogExchangePhoneBillShow: false,
      dialogExchangeCodeShow: false,
      onExchangeCodeObj: {
        expire: "",
        param: "",
        status: ""
      },
      dialogPhone: ''
    }
  },

  computed: {
    disBtn() {
      let onDate = Date.now()
      /*     if (this.productId === 'DTQ1' || this.productId === 'DTQ2' || this.productId === 'DTQ3' || this.productId === 'DTQ5') {
             return false
           } else {
             return onDate < 1620266400000
           }*/
      /*活动广告位及相关图片会在6月1日0时上线，但活动开始时间为6月1日17:00，在此之前奖品为无法兑换状态，立即邀请按钮也无法点击邀请；17:00之后按钮恢复正常状态。*/

      return onDate < ActivityStartTime


    },
    onCodeCateory() {
      let that = this
      if (this.$route.query.productId) {
        let rObj = exchangeList.find(obj => obj.productId === that.$route.query.productId)
        if (rObj) {
          return rObj
        } else {
          return {}
        }
      } else {
        return {}
      }
    },
    phoneState() {
      return /^1[3456789]\d{9}$/.test(this.dialogPhone);
    }
  },

  directives: {
    numberOnly: {
      bind: function (el) {
        el.handler = function () {
          el.value = el.value.replace(/\D+/, '')
        }
        el.addEventListener('input', el.handler)
      },
      unbind: function (el) {
        el.removeEventListener('input', el.handler)
      },


    }
  },
  mounted() {
    this.getPageInfo()
  },
  methods: {
    copyExchangeCode() {
      let _this = this;
      let zClassName = '.cobyOrderSn'
      let clipboard = new this.clipboard(zClassName);
      clipboard.on('success', function () {
        _this.$toast("复制成功")
      });
      clipboard.on('error', function () {
        _this.$toast("复制失败")
      });
    },
    // eslint-disable-next-line no-unused-vars
    dialogExchangePhoneBillBeforeClose(action, done) {
      if (action === "confirm") {
        if (!this.phoneState) {
          return done(false)
        } else {
          return done()
        }

      } else {

        return done()
      }

    },
    getPageInfo() {
      let robj = new FormData();
      let that = this
      robj.append('token', this.$store.state.user.token)
      robj.append('deviceCoding', this.$store.state.user.deviceCoding)
      robj.append('activityNo', this.$store.state.activityNo)
      robj.append('productId', this.$route.query.productId)
      findCostLogList(robj).then(res => {
        console.log(res)
        if (res.respcod === '01') {

          that.logList = res.data


        } else {
          this.$toast(res.respmsg)
        }


      }).catch(onerror => {
        console.error(onerror)
        this.$toast('网络错误')
      })
    },
    prepaidRefill(obj) {
      console.log(obj)
      let that = this
      if (this.onCodeCateory.type === 3) {
        this.onExchangePhoneBillObj = obj
        this.dialogPhone = '';
        this.dialogPrepaidRefillShow = true;
      } else {
        let robj = new FormData();

        robj.append('token', this.$store.state.user.token)
        robj.append('deviceCoding', this.$store.state.user.deviceCoding)
        robj.append('activityNo', this.$store.state.activityNo)
        // robj.append('productId', this.onExchangePhoneBillObj.productId)
        robj.append('orderNo', obj.orderNo)


        recharge(robj).then(res => {

          if (res.respcod === '01') {

            that.getPageInfo()
          } else {
            this.$toast(res.respmsg)
          }


        }).catch(onerror => {
          console.error(onerror)
          this.$toast('网络错误')
        })
      }

    },
    toRecharge() {
      let that = this
      if (!this.phoneState) {
        this.$toast('手机号格式错误')
        return false;
      }
      if (window._czc) {

        window._czc.push(['_trackEvent', '绿色能量6月', '话费再次充值', '', 1, '']);

      }
      let robj = new FormData();

      robj.append('token', this.$store.state.user.token)
      robj.append('deviceCoding', this.$store.state.user.deviceCoding)
      robj.append('activityNo', this.$store.state.activityNo)
      // robj.append('productId', this.onExchangePhoneBillObj.productId)
      robj.append('orderNo', this.onExchangePhoneBillObj.orderNo)
      robj.append('mobileNo', this.dialogPhone)

      recharge(robj).then(res => {

        if (res.respcod === '01') {
          this.$store.dispatch('handGetUserCoinInfo', {
            token: this.$store.state.user.token,
            deviceCoding: this.$store.state.user.deviceCoding
          }).then(res => {
            console.log(res)
          })
          // that.onExchangeCodeObj.param = res.data.param
          // that.onExchangeCodeObj.productId = productId
          // that.dialogPrepaidRefillShow = false
          this.$dialog.alert({
            title: `兑换成功`,
            message: `${res.respmsg}`
          })
              .then(() => {
                // on confirm

                that.getPageInfo()
              })

        } else {
          this.$toast(res.respmsg)
        }


      }).catch(onerror => {
        console.error(onerror)
        this.$toast('网络错误')
      })
    },
    toExchangePhoneBill() {
      console.log('toExchangePhoneBill')
      let that = this

      // if (this.prepaidRefillAjaxStatus) {
      //   return false;
      // }
      if (!this.phoneState) {
        this.$toast('手机号格式错误')
        return false;
      }
      if (window._czc) {

        window._czc.push(['_trackEvent', '绿色能量6月', '话费充值', '', 1, '']);

      }
      let robj = new FormData();

      robj.append('token', this.$store.state.user.token)
      robj.append('deviceCoding', this.$store.state.user.deviceCoding)
      robj.append('activityNo', this.$store.state.activityNo)
      robj.append('productId', this.onCodeCateory.productId)
      robj.append('mobileNo', this.dialogPhone)

      costCoin(robj).then(res => {

        if (res.respcod === '01') {
          this.$store.dispatch('handGetUserCoinInfo', {
            token: this.$store.state.user.token,
            deviceCoding: this.$store.state.user.deviceCoding
          }).then(res => {
            console.log(res)
          })
          // that.onExchangeCodeObj.param = res.data.param
          // that.onExchangeCodeObj.productId = productId
          // that.dialogExchangePhoneBillShow = false
          this.$dialog.alert({
            title: `兑换成功`,
            message: `充值结果稍有延迟，请耐心等待`,
            confirmButtonColor: '#2FBD4B',
            confirmButtonText: '确定'
          })
              .then(() => {
                // on confirm

                that.getPageInfo()
              })


        } else {
          this.$toast(res.respmsg)
        }


      }).catch(onerror => {
        console.error(onerror)
        this.$toast('网络错误')
      })
    },
    toExchange() {
      let that = this
      if (this.onCodeCateory.coinNum > this.$store.state.user.coinNum) {
        this.$toast('能量不足')
        return false;
      }
      if (this.disBtn) {

        this.$toast('兑换尚未开放')

        return false
      }
      if (this.onCodeCateory.type === 3) {
        this.dialogPhone = '';
        this.dialogExchangePhoneBillShow = true
      } else if (this.onCodeCateory.type === 2 || this.onCodeCateory.type === 1) {
        this.$dialog.confirm({
          title: `${this.onCodeCateory.productName}`,
          message: `将消耗${this.onCodeCateory.coinNum}能量`,
          confirmButtonColor: '#2FBD4B',
          confirmButtonText: '确认兑换'
        })
            .then(() => {
              // on confirm
              that.exchangeActivationCodeAjax(that.onCodeCateory.productId, that.onCodeCateory.productName, that.onCodeCateory.type)
            })
            .catch(() => {
              // on cancel

            })
      }

    },
    /**
     *
     * @param productId 产品编码
     * @param productName  产品名称（例如：5元话费券）
     * @param type
     * @param mobileNo 手机号（充值手机号，可为空）
     */
    exchangeActivationCodeAjax(productId = '', productName = '', type = 2) {
      console.log(type)
      let that = this

      let robj = new FormData();

      robj.append('token', this.$store.state.user.token)
      robj.append('deviceCoding', this.$store.state.user.deviceCoding)
      robj.append('activityNo', this.$store.state.activityNo)
      robj.append('productId', productId)
      robj.append('productName', productName)

      costCoin(robj).then(res => {
        console.log(res)
        if (res.respcod === '01') {
          if (type === 2) {
            if (res.data.status === '01') {
              that.onExchangeCodeObj.param = res.data.param
              that.onExchangeCodeObj.productId = productId
              that.dialogExchangeCodeShow = true
            } else if (res.data.status === '02') {
              this.$toast('获取失败')
            }
          } else if (type === 1) {
            this.$dialog.alert({
              title: `兑换成功`,
              message: `已发放至${phoneFilter2(that.$store.state.user.phone)}账号`,

            })
                .then(() => {
                  // on confirm
                  that.getPageInfo()
                })

          }


          console.log(1)
        } else {
          this.$toast(res.respmsg)
        }


      }).catch(onerror => {
        console.error(onerror)
        this.$toast('网络错误')
      })
    },
  }

}
</script>

<style lang="less" scoped>
.ActivationCode {
  background-color: #FFFFFF;
  margin: 0;
  height: 100vh;
  text-align: left;
  display: flex;
  flex-direction: column;
}

.yui_page-main {
  flex: 1;
  overflow-y: scroll;
}

.use-rule {

  border-top: 3vw solid #F5F5F5;
  text-align: justify;
  font-size: 3.6vw;
  line-height: 2;
  color: #999999;
  padding: 2vw 5vw;

  p {
    margin: 0;
  }

  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    margin: 0;
  }

}

.y_cell-activity-code {
  .van-cell__value {
    flex: initial;
  }
}


.yui-input-box {
  width: 70vw;
  display: block;
  margin-top: 2vw;
  margin-bottom: 3vw;
  margin-left: auto;
  margin-right: auto;
  //background-color: #F5F5F5;

  .yui-input {
    max-width: 100%;
    border: none;
    font-size: 3.75vw;
    padding: 3vw 5vw;
    background-color: #F5F5F5 !important;
    border-radius: 2vw;
    height: 5vw;
    line-height: 3.75vw;
    width: 60vw;
    color: #595959 !important;
    text-align: center;

    &::placeholder {
      font-size: 3.75vw;
      line-height: 4vw;
      color: #b3b3b3;
    }

    &:disabled {
      opacity: 1 !important;
    }

    &:focus,
    &:hover {
      background-color: #ffffff70;
      color: #fad7c5;
    }
  }
}


.yui_footer {
  position: relative;
  padding: 10px 20px 20px;
  //position: fixed;
  //bottom: 0;
  //left: 0;
  //right: 0;
  box-shadow: 0px -2px 7px 0px rgba(18, 18, 18, 0.05);
  background-color: #FFFFFF;
}

.y_btn {
  margin: 2vw auto;
  display: block;
}
</style>